import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'app-hidden-input',
  template: '',
  standalone: true,
})
export class FormlyHiddenTypeComponent extends FieldType {}
